export default "__VITE_ASSET__TX2BRQ_P__"